import React, { useContext } from "react";
import { RestContext } from "../../App";
import { DASHBOARD_URL } from "../../serverConfig";
import { Button } from "reactstrap";
import DataSheetAdmin from "./DataSheetAdmin";

function OtherAdmin({}) {
	const { sendGetRequest } = useContext(RestContext);

	const refreshParameters = () => {
		sendGetRequest(DASHBOARD_URL + "/parameters/refresh");
	};

	return (
		<div id="other-admin">
			<DataSheetAdmin />
			<div id="other-admin-button-container">
				<h3>Miscellaneous</h3>
				<Button
					id="refresh-parameters-button"
					onClick={refreshParameters}
				>
					Refresh Dashboard Parameters
				</Button>
			</div>
		</div>
	);
}

export default OtherAdmin;
